import {css} from 'styled-components';

import {Icon} from '../../elements/Icon/Icon';
import {FormControl} from '../form-containers/FormControl';
import {FormSelectArrowIcon} from '../form-control-features/FormSelectArrowIcon';
import {ErrorMessageText} from '../form-labels/FormErrorMessage';
import {WordFix} from '../form-labels/FormLabeledSuffixPrefix';

export const formFocus = () => `
    // ------------------- //
    // === Focus Setup === //
    // ------------------- //
    &:has(input:focus),
    &:has(textarea:focus) {
        ${FormControl} {
            background: var(--form-box-background-focus-color);
            border-color: var(--form-box-border-focus-color);
            transition: var(--form-animation-duration);
        }
        ${WordFix} {
            background: var(--form-labeled-affix-background-focus-color);
            border-color: var(--form-box-border-focus-color);
            color: var(--primary);
            transition: var(--form-animation-duration);
        }
        ${FormSelectArrowIcon.Container} {
            background-image: linear-gradient(
                to right,
                var(--form-box-background-transparent-color),
                var(--form-box-background-focus-color),
                var(--form-box-background-focus-color)
            );
        }
    }


    // ------------------- //
    // === Hover Setup === //
    // ------------------- //
    &:has(input:hover) {
        ${FormControl} {
            border-color: var(--form-box-hover-background-color);
            transition: var(--form-animation-duration);
        }
        ${WordFix} {
            border-color: var(--form-box-hover-background-color);
            transition: var(--form-animation-duration);
        }
    }
   &:hover{
        ${FormControl} {
            border-color: var(--form-box-hover-background-color);
            transition: var(--form-animation-duration);
        }
        ${WordFix} {
            border-color: var(--form-box-hover-background-color);
            transition: var(--form-animation-duration);
        }
    }
`;

export const formValidationError = css`
    &:has(${ErrorMessageText.toString()}) {
        > *,
        ${Icon.Wrapper} svg {
            color: var(--danger);
        }
        --form-box-background-color: var(--form-box-error-background-color) !important;
        --form-box-border-color: var(--danger) !important;
        --form-labeled-affix-background-color: var(--form-labeled-affix-error-background-color) !important;
        --form-labeled-affix-border-color: var(--danger) !important;
    }
`;
